const TeamAccessPending: FC = () => (
    <div className="p-3">
        <div className="alert alert-warning">
            Your membership to this team is still pending. Talk to your coach about approving your access.
        </div>
    </div>
);

export default TeamAccessPending;
